import { PlayCircleOutline } from '@styled-icons/material';
import { Box, FlexBox, Position, Text } from '@trmediaab/zebra';
import { createStyledIcon } from '@trmediaab/zebra-icons';

import Img from '~/components/Img';
import { ThemedLink } from '~/components/ThemedLink';

import Breadcrumb from './Breadcrumb';
import { buildArticleLink, getBetTypeColor, getMetaLabels } from './utils';

const PlayIcon = createStyledIcon(PlayCircleOutline);

const FloatingPlayIcon = () => (
  <Position.absolute
    width={{ _: '40px', md: '80px' }}
    height={{ _: '40px', md: '80px' }}
    left={{ _: 'calc(50% - 20px)', md: 'calc(50% - 40px)' }}
    top={{ _: 'calc(50% - 20px)', md: 'calc(50% - 40px)' }}
  >
    <PlayIcon color="white" />
  </Position.absolute>
);

const Overlay = () => (
  <Position.absolute
    left={0}
    right={0}
    top={0}
    bottom={0}
    bg="black"
    opacity={0.2}
  />
);

export default function TVTeaser({ data, round }) {
  return (
    <Box>
      <ThemedLink
        to={buildArticleLink(data)}
        sx={{
          "&:hover [data-id='headline'] ": {
            textDecoration: 'underline',
          },
        }}
      >
        <FlexBox
          flexDirection="column"
          bg="white"
          p={{ _: 3, md: '3,5' }}
          pr={{ _: 0, md: undefined }}
        >
          <Box display={{ _: 'block', md: 'none' }}>
            <Breadcrumb
              type={data.type}
              meta={getMetaLabels(data.round)}
              color={getBetTypeColor(data, round)}
            />
          </Box>

          <FlexBox gap={{ _: 1, md: 3 }}>
            <FlexBox
              flexDirection="column"
              flex={1}
              minHeight={{ _: undefined, md: 120 }}
              gap="1"
            >
              <Box display={{ _: 'none', md: 'block' }}>
                <Breadcrumb
                  type={data.type}
                  meta={getMetaLabels(data.round)}
                  color={getBetTypeColor(data, round)}
                />
              </Box>

              <Text
                fontSize={{ _: 3, md: 5 }}
                fontWeight="bold"
                color="black"
                data-id="headline"
              >
                {data.teaser_headline || data.headline}
              </Text>

              <Text fontSize={{ _: 1, md: 2 }} color="greys.6">
                {data.teaser || data.preamble}
              </Text>
            </FlexBox>

            <Box
              display={{ _: 'block', md: 'none' }}
              maxHeight="56px"
              sx={{ position: 'relative' }}
            >
              <Img
                width={100}
                aspectRatio={[16, 9]}
                image={data.teaser_image || data.image}
              />
              <Overlay />
              <FloatingPlayIcon />
            </Box>

            <Box
              display={{ _: 'none', md: 'block' }}
              sx={{ position: 'relative' }}
            >
              <Img
                width={260}
                aspectRatio={[16, 9]}
                image={data.teaser_image || data.image}
              />
              <Overlay />
              <FloatingPlayIcon />
            </Box>
          </FlexBox>
        </FlexBox>
      </ThemedLink>
    </Box>
  );
}
